import { useEffect, useState } from 'react';
import { requestPushPermission } from '../utils/pushManager';
import { API_URL } from '../utils/api';

interface UsePushPermissionOptions {
  orderId: string | undefined;
  orderStatus: string | undefined;
  addDebug: (msg: string) => void;
}

interface UsePushPermissionReturn {
  pushRequested: boolean;
}

export function usePushPermission(options: UsePushPermissionOptions): UsePushPermissionReturn {
  const { orderId, orderStatus, addDebug } = options;

  const [pushRequested, setPushRequested] = useState(false);

  useEffect(() => {
    if (!orderId || pushRequested) return;
    if (orderStatus && ['COMPLETED', 'CANCELLED'].includes(orderStatus)) {
      addDebug(`[push] skip — status=${orderStatus}`);
      return;
    }
    addDebug(`[push] will request in 3s (order=${orderId.slice(0, 8)})`);
    const timer = setTimeout(async () => {
      setPushRequested(true);
      // Store for debug buttons
      (window as any).__pushOrderId = orderId;
      (window as any).__pushApiBase = API_URL || '';
      const ok = await requestPushPermission(orderId, addDebug);
      if (ok) {
        // Verify backend can send
        try {
          const base = API_URL || '';
          const res = await fetch(`${base}/api/orders/push-debug`);
          const data = await res.json();
          addDebug(`[push-backend] ${data.note}`);
          if (data.adminError) addDebug(`[push-backend] err: ${data.adminError}`);
        } catch (e: any) {
          addDebug(`[push-backend] check failed: ${e?.message}`);
        }
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [orderId, pushRequested, addDebug, orderStatus]);

  return { pushRequested };
}
